import React from 'react'
import {useIntl} from 'react-intl'
import {ACTION_COLORS} from '../core/OrderedProductsModel'

interface ActionButtonProps {
  type: keyof typeof ACTION_COLORS
  value: number
  isClicked: boolean
  onClick: (value: number) => void
}

const ActionButton: React.FC<ActionButtonProps> = ({type, value, isClicked, onClick}) => {
  const {formatMessage} = useIntl()
  const colors = ACTION_COLORS[type]

  return (
    <button
      className='btn w-100 mb-2'
      style={{
        backgroundColor: isClicked ? colors.disabled : colors.original,
        color: '#000',
        cursor: isClicked ? 'not-allowed' : 'pointer',
        border: 'none',
        transition: 'all 0.3s ease',
        opacity: isClicked ? 0.8 : 1,
      }}
      disabled={isClicked}
      onClick={() => onClick(value)}
    >
      {formatMessage({id: `ORDERED_PRODUCTS.ACTIONS.${type.toUpperCase()}`})}
    </button>
  )
}

export default ActionButton
